import { useItemsDataGrid, useItemsToolbar } from '../items-landing.hooks';
import { useUtilityDrawer } from 'components/drawers/utility-drawer/utility-drawer.hooks';
import { ItemResult } from 'api/ordering-service/ordering-service.types';
import ItemQuickDetailsDrawer from 'components/drawers/products-drawer/items-drawer/items-drawer.component';
import ItemDeleteDrawer from '../../item-delete-drawer/item-delete-drawer.component';
import ItemsDeleteDrawer from '../../items-delete-drawer/items-delete-drawer.component';
import MenuManagementBulkEditDataGrid from 'pages/menu-management/menu-management-bulk-edit-data-grid/menu-management-bulk-edit-data-grid.component';

type ItemsDataGridProps = {
  isImported?: boolean;
};

const ItemsDataGrid = ({ isImported = false }: ItemsDataGridProps) => {
  const itemDetailsDrawer = useUtilityDrawer<ItemResult>();
  const deleteConfirmationDrawer = useUtilityDrawer<ItemResult>();
  const bulkDeleteConfirmationDrawer = useUtilityDrawer<ItemResult>();
  const columns = useItemsDataGrid(isImported, deleteConfirmationDrawer);
  const { toolbar, initialState } = useItemsToolbar(
    bulkDeleteConfirmationDrawer,
    isImported,
  );

  return (
    <>
      <MenuManagementBulkEditDataGrid
        columns={columns}
        toolbar={toolbar}
        initialState={initialState}
        data-testid={
          isImported ? 'ItemsImportedDataGrid' : 'ItemsNativeDataGrid'
        }
        onRowClick={params => {
          itemDetailsDrawer.setDrawerData(params?.row);
          itemDetailsDrawer.setOpen(true);
        }}
        getRowId={(row: ItemResult) => row?.itemId}
      />
      <ItemQuickDetailsDrawer {...itemDetailsDrawer} />
      <ItemDeleteDrawer {...deleteConfirmationDrawer} />
      <ItemsDeleteDrawer
        open={bulkDeleteConfirmationDrawer.open}
        close={bulkDeleteConfirmationDrawer.close}
      />
    </>
  );
};

export default ItemsDataGrid;
